export const getEnv = (): 'staging' | 'prod' | 'dev' | 'local' => {
  const _env = (process.env.REACT_APP_ENV || '').toLowerCase().trim()
  if (_env === 'staging') return 'staging'
  if (_env === 'prod') return 'prod'
  if (_env === 'production') return 'prod'
  if (_env === 'local') return 'local'
  return 'dev'
}
